import React from "react";

export const AboutAppText = () => {
	return (
		<div className="big-text">
			<h1>About Application</h1>
			<div style={{ display: "flex" }}>
				<>
					<p className="mr-50">
						TenPinCams SIA
						<br />
						Reg. Nr. 42103088398
						<br />
						E-mail: info@tenpincam.com
						<br />
						Phone: +37129215590
					</p>
				</>
				<p>
					The TenPinCam platform has been created to facilitate Ten Pin Bowlers within the framework of sports and
					entertainment formats.
					<br />
					<br />
					The Platform is designed for the development of bowling as a sport, increasing accessibility and uniting
					players.
					<br />
					<br />
					The principle of the TenPinCam project is based on the application of technology (video cameras, Internet
					networking, user’s device) for international online play.
					<br />
					<br />
					The game scores depend exclusively on the player’s skills (Game of Skill).
					<br />
					<br />
					The users of the platform play bowling on lanes of bowling centres equipped with a set of TenPinCam video
					cameras, the game scores are recorded and controlled through the TenPinCam platform interface.
					<br />
					<br />
					The game is played in compliance with the rules of the World Tenpin Bowling Federation (WTBF).
				</p>
			</div>
		</div>
	);
};
